import { Grid } from 'semantic-ui-react';
import { node, oneOfType, string } from 'prop-types';
import React from 'react';

const LineInfo = ({ label, value }) => (
  <Grid.Row style={{ padding: '8px 0' }}>
    <Grid.Column width={4}>{label}</Grid.Column>
    <Grid.Column width={12}>{value || '-'}</Grid.Column>
  </Grid.Row>
);

LineInfo.propTypes = {
  label: oneOfType([node, string]).isRequired,
  value: oneOfType([node, string]).isRequired,
};

export default LineInfo;
